import PropTypes from 'prop-types';
import POVBlock from "../POVBlock/POVBlock";

export default PropTypes.shape({
  title: PropTypes.string,
  slug: PropTypes.string,
  localizationSlug: PropTypes.string,
  snippet: PropTypes.string,
  capabilitiesOverviewBlock: PropTypes.oneOfType(POVBlock),
  logo: PropTypes.shape({
    fluid: PropTypes.object
  })
});
